module.exports = __webpack_public_path__ + "static/img/soil-fertility.ecfe35f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/product/soil-fertility.jpg
// module id = mZDE
// module chunks = 1